import {
    List
} from "@mui/material";
import MaterialButton from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { each } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import OverlayTitle from "../generics/components/overlay-title";
import InsightDialogItem from "./insight-dialog-items";
import { Check, Clear } from "@mui/icons-material";

const chatWidgetStyle = {
  width: "100%",
  backgroundColor: "transparent",
  display: "block",
  height: "100%",
};

interface IProps {
  attachedFindings: any;
  findingLinks: any;
  closeCommentView: Function;
  invalidate: Function;
  validate: Function;
  canEditCanvas: boolean;
  updatePopupHeight: Function;
  findingLinksUser: object;
}

const InsightsDialog = (props: IProps) => {
  const {
    attachedFindings,
    findingLinks,
    closeCommentView,
    invalidate,
    validate,
    canEditCanvas,
    updatePopupHeight,
    findingLinksUser,
  } = props;

  const theme = useTheme();
  
  const [findingState, setFindingState] = useState({
    loadingInsights: true,
    findings: [],
  });
  const [matchedInsightGroup, setMatchedInsightGroup] =
    useState<any>(undefined);
  const rootNode = useRef<HTMLDivElement | null>(null);
  const scrollNode = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const findingSupports = {};

    findingLinks?.forEach((finding) => {
      findingSupports[finding?.findingID] = finding?.supports;
    });

    setFindingState({
      loadingInsights: false,
      findings: attachedFindings?.map((finding) => ({
        ...finding,
        supports: findingSupports[finding?.findingID],
      })),
    });
    (typeof window !== "undefined" ? document : {}).addEventListener(
      "keyup",
      handleEscapeCheck,
      false
    );
    (typeof window !== "undefined" ? document : {}).addEventListener(
      "mousedown",
      handleEscapeCheck,
      false
    );

    return () => {
      (typeof window !== "undefined" ? document : {}).removeEventListener(
        "keyup",
        handleEscapeCheck,
        false
      );
      (typeof window !== "undefined" ? document : {}).removeEventListener(
        "mousedown",
        handleEscapeCheck,
        false
      );
    };
  }, [attachedFindings, findingLinks]);

  const handleProcessEscaping = useCallback(() => {
    closeCommentView();
  }, [closeCommentView]);

  const handleEscapeCheck = useCallback(
    (event: any) => {
      if (event.key === "Escape") {
        handleProcessEscaping();
      } else if (
        event.target &&
        rootNode.current &&
        !rootNode.current.contains(event.target)
      ) {
        handleProcessEscaping();
      }
    },
    [handleProcessEscaping]
  );

  const renderFindingTable = () => {
    let findingSet = [];
    let firstInsight = true;

    each(findingState.findings, (finding) => {
      findingSet.push(
         <InsightDialogItem 
           finding={finding}
           updatePopupHeight={updatePopupHeight}
           handleProcessEscaping={handleProcessEscaping}
           findingLinksUser={findingLinksUser}
           matchedInsightGroup={matchedInsightGroup} 
           setMatchedInsightGroup={setMatchedInsightGroup}
         />
        );
      firstInsight = false;
    });

    return (
      <List
        sx={{
          maxHeight: "80vh",
          width: "100%",
          overflowY: "auto",
          overflowX: "clip",
          padding: "0 10px",
        }}
      >
        {findingSet}
      </List>
    );
  };

  const renderActions = () => {
    return (
      <div
        style={{
          // backgroundColor: GOOGLE_OFFWHITE_BACKGROUND_COLOR,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "8px",
        }}
      >
        <MaterialButton
          variant="contained"
          // color="success"
          onClick={() => {
            validate();
          }}
          startIcon={<Check sx={{ color: "#16A34A" }} />}
          sx={{
            marginRight: "8px",
            color: "black",
            backgroundColor: "#F0FDF4",
            border:"1px solid #E5E7EB",
            "&:hover": {
              border:"1px solid #16A34A",
              backgroundColor: "#F0FDF4",
            },
          }}
          disabled={!canEditCanvas}
        >
          Validate
        </MaterialButton>
        <MaterialButton
          variant="contained"
          // color="error"
          onClick={() => {
            invalidate();
          }}
          sx={{
            marginRight: "8px",
            color: "black",
            backgroundColor: "#FEF2F2",
            border:"1px solid #E5E7EB",
            "&:hover": {
              border:"1px solid #DC2626",
              backgroundColor: "#FEF2F2",
            },
          }}
          startIcon={<Clear sx={{ color: "#DC2626" }} />}
          disabled={!canEditCanvas}
        >
          Invalidate
        </MaterialButton>
        <MaterialButton
          variant="contained"
          onClick={() => {
            closeCommentView();
          }}
          sx={{ marginLeft: "auto" }}
        >
          Close
        </MaterialButton>
      </div>
    );
  };

  return (
    <div
      ref={(rootNode) => (rootNode = rootNode)}
      style={{
        width: "425px",
        background: "white",
        border: "0px",
        borderRadius: "4px",
        boxShadow: theme?.custom?.menuBoxShadow,
        padding: "0px",
        margin: "0px",
      }}
    >
      <OverlayTitle
        title={`Insights ${
          findingState.findings?.length > 0
            ? `(${findingState?.findings?.length})`
            : `(0)`
        }`}
        onClose={() => {
          handleProcessEscaping();
        }}
      />
      <div style={chatWidgetStyle}>
        <div
          ref={(scrollNode) => (scrollNode = scrollNode)}
          style={{ width: "100%", height: "auto" }}
        >
          {renderFindingTable()}
        </div>
        {renderActions()}
      </div>
    </div>
  );
};
export default InsightsDialog;
